import React from 'react';
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader';
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar';
import AllOrders from '../../components/Shop/AllOrders';

const ShopAllOrders = () => {
  return (
    <div className="shop-all-orders-page-container">
      <DashboardHeader />
      <div className="shop-all-orders-page-content shop-management-layout">
        <div className="shop-all-orders-page-sidebar shop-management-sidebar-slot">
          <DashboardSideBar active={12} />
        </div>
        <main className="shop-all-orders-page-main shop-management-main-panel">
          <AllOrders />
        </main>
      </div>
    </div>
  );
};

export default ShopAllOrders;
